"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FB_SV_TIMESTAMP = void 0;
const tslib_1 = require("tslib");
const app_1 = tslib_1.__importDefault(require("firebase/app"));
require("firebase/database");
//watch out !!! this is actually type object, use it only before update in DB
exports.FB_SV_TIMESTAMP = app_1.default.database.ServerValue.TIMESTAMP;
//# sourceMappingURL=firebaseTypes.js.map